/**
 * This modules responsibility is to update the price high link in price high searches.
 * When the user interacts with filters in the page, this module will make sure to keep the
 * link up to date by contemplating the filters applied, so whenever clicked; the user gets
 * the same filters she/he is currently applying.
 */
import { map, distinctUntilChanged, filter, withLatestFrom } from 'rxjs/operators';
import { store$ } from "@redux/store";
import { selectFetchResultListingsStatus } from "features/searchResultsFacets";
import  LoadingStatus from "enums/loadingStatus";
import { onQueryStringChanged$ } from '../redux/observables';

/**
 * updatePriceHighLink: updates the href of the price high link in searches where price high is a filer.
 * @param {HTMLElement} priceHighLink is the anchor for price high searches in the HTML.
 * @param {HTMLElement} url to update the priceHighLink element.
 */
const updatePriceHighLink = ({priceHighLink, url}) => {
    priceHighLink.href = url;
}

/**
 * observable that emits a value every time results are loaded on screen.
 */
const onResultsLoaded$ = store$.pipe(
    map(selectFetchResultListingsStatus),
    distinctUntilChanged(),
    filter((status) => status === LoadingStatus.Succeeded)
)

/**
 * observable that takes the latest query string calculated value and emits it along the
 * price high link element for price high filters.
 */
onResultsLoaded$.pipe(
    withLatestFrom(onQueryStringChanged$),
    map(([, queryString]) => {
        const priceHighLink = document.querySelector('[data-next-price-high-link]');

        const urlUpdateInformation = {
            priceHighLink,
            url: null,
        };

        if (!priceHighLink) {
            return urlUpdateInformation;
        }

        const url = new URL(priceHighLink.href);
        const parameters = new URLSearchParams(queryString);
        
        parameters.set('pricehigh', priceHighLink.getAttribute("data-price-high"));
        url.search = parameters.toString();
        urlUpdateInformation.url = url.toString();

        return urlUpdateInformation;
    }),
    filter(({priceHighLink}) => priceHighLink),
).subscribe(updatePriceHighLink);